import { trackedArray } from "@ember/reactive/collections";
import { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";
import { buildCategoryGroup } from "../../lib/category-groups";

export default class AdminPluginsFlexibleRateLimitsRoute extends DiscourseRoute {
  @service site;

  titleToken() {
    return i18n("flexible_rate_limits.admin.title");
  }

  async model() {
    const data = await ajax("/admin/plugins/flexible-rate-limits/data.json");

    data.category_groups = trackedArray(
      (data.category_groups || []).map(buildCategoryGroup)
    );

    return data;
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    const usedIds = model.category_groups.flatMap((cg) => cg.categories);

    controller.availableCategoryIds = trackedArray(
      this.site.categories
        .map((category) => category.id)
        .filter((id) => !usedIds.includes(id))
    );
  }
}
